"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactToolbar = require("@cdk-uip/react-toolbar");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/**
 * CDK global header.
 */


var GlobalHeader = function GlobalHeader(_ref) {
  var className = _ref.className,
      fixed = _ref.fixed,
      adjust = _ref.adjust,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["className", "fixed", "adjust", "children"]);

  return _react2.default.createElement(_reactToolbar.Toolbar, {
    className: "cdk-global-header",
    fixed: fixed,
    adjust: adjust
  }, _react2.default.createElement(_reactToolbar.ToolbarRow, null, children));
};

GlobalHeader.propTypes = {
  /** Fix the header to the top of the page. */
  fixed: _propTypes.bool,

  /** Adjust content to take a fixed header into account */
  adjust: _propTypes.bool
};
GlobalHeader.defaultProps = {
  fixed: true
};
exports.default = GlobalHeader;